import Base from '../base';

class Carriers extends Base {
	getList() {
		const api = this._api
			.url('/ref/carriers')
			.GET;
		return this.request(api);
	}

	createCarrier(body) {
		const api = this._api
			.url('/ref/carrier')
			.data(body)
			.POST;
		return this.request(api);
	}

	editCarrier(body) {
		const api = this._api
			.url(`/ref/carrier/${body.id}`)
			.data(body)
			.PUT;
		return this.request(api);
	}

	deleteCarrier(id) {
		const api = this._api
			.url(`/ref/carrier/${id}`)
			.DELETE;
		return this.request(api);
	}

}

export default new Carriers();
